import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["content", "icon"]

    connect() {
        // Collapsed by default on mobile
        if (window.innerWidth < 768) {
            this.collapse()
        } else {
            this.expand()
        }
    }

    toggle() {
        if (this.contentTarget.classList.contains("hidden")) {
            this.expand()
        } else {
            this.collapse()
        }
    }

    expand() {
        this.contentTarget.classList.remove("hidden")
        this.iconTarget.style.transform = "rotate(180deg)"
        this.element.querySelector("button").setAttribute("aria-expanded", "true")
    }

    collapse() {
        this.contentTarget.classList.add("hidden")
        this.iconTarget.style.transform = "rotate(0deg)"
        this.element.querySelector("button").setAttribute("aria-expanded", "false")
    }
}